import React from "react";

const TAG_REGEX = /\[(u|b|i)\]([\s\S]*?)\[\/\1\]/i;

function parseFormatted(text, keyRef) {
  const match = text.match(TAG_REGEX);

  if (!match || match.index === undefined) {
    return [text];
  }

  const before = text.slice(0, match.index);
  const tag = match[1].toLowerCase();
  const inner = match[2];
  const after = text.slice(match.index + match[0].length);

  const key = "fmt_" + keyRef.value++;

  let tagNode;

  if (tag === "u") {
    tagNode = (
      <u key={key}>
        {parseFormatted(inner, keyRef)}
      </u>
    );
  } else if (tag === "b") {
    tagNode = (
      <strong key={key}>
        {parseFormatted(inner, keyRef)}
      </strong>
    );
  } else {
    tagNode = (
      <em key={key}>
        {parseFormatted(inner, keyRef)}
      </em>
    );
  }

  return [
    ...parseFormatted(before, keyRef),
    tagNode,
    ...parseFormatted(after, keyRef)
  ];
}

export function FormattedText(props) {
  const text = props.text || "";
  const keyRef = { value: 0 };
  const lines = text.split("\n");

  return (
    <>
      {lines.map(function (line, idx) {
        return (
          <span key={"line_" + idx}>
            {parseFormatted(line, keyRef)}
            {idx < lines.length - 1 ? <br /> : null}
          </span>
        );
      })}
    </>
  );
}
